module.exports = __webpack_public_path__ + "img/robo.20333f46.gif";